import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/neamatmim/Code/RedQ/startuplanding/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "nextjs-version"
    }}>{`Nextjs Version:`}</h2>
    <p>{`we provide ready to use sendgrid and mailchimp integration which is define under `}<inlineCode parentName="p">{`src/pages/api`}</inlineCode>{` folder.
use this you need to set required credentials at `}<inlineCode parentName="p">{`.env.local`}</inlineCode>{` file.`}</p>
    <pre><code parentName="pre" {...{}}>{`MAILCHIMP_API_KEY=[your-mailchimp-api-key]
MAILCHIMP_LIST_ID=[your-mailchimp-list-id-key]
SENDGRID_API_KEY=[your-sendgrid-api-key]
`}</code></pre>
    <p>{`to use it on client site we provide a example file at `}<inlineCode parentName="p">{`src/components/subscribe`}</inlineCode>{`. please customize it according to your requirement.`}</p>
    <h2 {...{
      "id": "gatsby-version"
    }}>{`Gatsby Version`}</h2>
    <p>{`we suggest to use `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/plugins/gatsby-plugin-mailchimp/"
      }}>{`gatsby-plugin-mailchimp`}</a>{` for mailchimp integration. please follow their docs for more info.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      